import { render } from "./PmpkConclusionCard.vue?vue&type=template&id=6539aab1&scoped=true"
import script from "./PmpkConclusionCard.vue?vue&type=script&lang=js"
export * from "./PmpkConclusionCard.vue?vue&type=script&lang=js"

import "./PmpkConclusionCard.vue?vue&type=style&index=0&id=6539aab1&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6539aab1"]])

export default __exports__